import { AttaHttpClientFactory } from './http/AttaHttpClientFactory'
import { IApiResponse } from '@/interfaces/IApiResponse'
import { INotificationsResponse } from '@/components/Notifications/NotificationItemBase'

const http = AttaHttpClientFactory.create(import.meta.env.VUE_APP_API_ATTA_SERVICES)

export class NotificationService {
	/**
	 * Set all notification from current user as read
	 * @returns
	 */
	static async setAllAsRead() {
		let response = await http.post(`/notification/read-all`)
		return response.data
	}
	/**
	 * Set a notification as read
	 * @param id
	 * @returns
	 */
	static async setAsRead(id: string) {
		let response = await http.post(`/notification/read/${id}`)
		return response.data
	}

	/**
	 * Get all user notifications
	 */
	static async get() {
		const response = await http.get<IApiResponse<INotificationsResponse[]>>('/notification')

		return response.data
	}
}
